<ion-item class="option accept" lines="none">
  <span>{{ question }}</span>
  <ion-checkbox
    #acceptCheckbox
    [ngModel]="acceptChecked"
    (ngModelChange)="onAcceptChecked()"
    slot="start"
    color="secondary">
  </ion-checkbox>
</ion-item>
@if (canDecline) {
  <ion-item class="option decline" lines="none">
    <span>I want to decline this request.</span>
    <ion-checkbox
      #declineCheckbox
      [ngModel]="declineChecked"
      (ngModelChange)="onDeclineChecked()"
      slot="start"
      color="secondary">
    </ion-checkbox>
  </ion-item>
}

@if (declining && enableDeclineWarning) {
  <ion-item class="decline-warning" lines="none">
    <ion-icon slot="start" name="information-circle-outline"></ion-icon>
    <span>Please note, declining this request will complete your slip response.</span>
  </ion-item>
}
@if (progress?.error) {
  <ion-row class="ion-justify-content-center">
    <div class="error-container">
      <p [innerHtml]="progress.error"></p>
      @if (progress.showReload) {
        <ion-button class="reload-button ph-btn-white" (click)="reloadSlip.emit()"
          >Refresh slip</ion-button
          >
        }
      </div>
    </ion-row>
  }
  @if (!progress?.showReload) {
    <ion-row class="ion-justify-content-center">
      <ion-button [disabled]="!isFormValid" class="submitButton" color="secondary" (click)="onSubmit()">
        @if (!progress?.working) {
          <span>Submit</span>
        }
        @if (progress?.working) {
          <ion-spinner name="crescent"></ion-spinner>
        }
      </ion-button>
    </ion-row>
  }
